import { BaseForm } from './base-form';
import { UiColumn } from './ui-column';
import { GridSettings } from '../interfaces/grid-settings.interface';

export abstract class BaseSearchForm<TRow> extends BaseForm {

  data: Array<TRow> = [];
  gridSettings: GridSettings<TRow>;
  constructor() {
    super();
  }

  get getSearchFormName() {
    return this.name ?? "";
  }

  set setSearchFormName(label: string) {
    this.name = label;
  }

}
